import { create } from 'zustand';

export type EditablePageLink = {
  /** Canonical page path, without `?edit`. */
  href: string;
  editing: boolean;
};

interface AppState {
  showGlobalFooter: boolean;
  setShowGlobalFooter: (show: boolean) => void;
  /** Set while the viewer can edit the page on screen, so the top bar can offer Edit when page actions are hidden. */
  editablePage: EditablePageLink | null;
  setEditablePage: (page: EditablePageLink | null) => void;
  /** Raw page `width` variable. null means the shell default (1400px). */
  pageWidth: string | null;
  setPageWidth: (width: string | null) => void;
  /** Hides app chrome (nav, footer, max-width) for file browser routes — in-app fullscreen, not browser Fullscreen API. */
  fileBrowserImmersive: boolean;
  setFileBrowserImmersive: (v: boolean) => void;
}

export const useAppStore = create<AppState>((set) => ({
  showGlobalFooter: true,
  setShowGlobalFooter: (show) => set({ showGlobalFooter: show }),
  editablePage: null,
  setEditablePage: (page) => set({ editablePage: page }),
  pageWidth: null,
  setPageWidth: (width) => set({ pageWidth: width }),
  fileBrowserImmersive: false,
  setFileBrowserImmersive: (v) => set({ fileBrowserImmersive: v }),
}));
